import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkbox-uncheck",
  "use": "checkbox-uncheck-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkbox-uncheck\">\n<rect x=\"0.5\" y=\"0.5\" width=\"17\" height=\"17\" rx=\"3.5\" stroke=\"#E0E0E0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol